import React, {memo} from 'react';
import {Divider, Layout} from 'antd';

import Link from '../text/Link';
import RightAddress from '../header/RightAddress';
import Title from '../text/Title';

const Footer = memo(() => {
  return (
    <div style={{padding: 30, backgroundColor: '#f0f2f5'}}>
      <div
        style={{
          textAlign: 'center',
          display: 'flex',
          justifyContent: 'center',
          flexDirection: 'column',
          alignContent: 'center',
          alignItems: 'center',
        }}
      >
        <RightAddress customIconStyle={{fontSize: 30, marginRight: 15}} />
        <div style={{display: 'flex', marginTop: 15}}>
          <Link
            customStyle={{fontWeight: 600, marginRight: 15, textSize: 18}}
            text="Home"
            path="/home"
          />

          <Link
            customStyle={{fontWeight: 600, marginRight: 15, textSize: 18}}
            text="Products"
            path="/home"
          />

          <Link
            customStyle={{fontWeight: 600, marginRight: 15, textSize: 18}}
            text="Contact"
            path="/contact"
          />

          <Link
            customStyle={{fontWeight: 600, marginRight: 15, textSize: 18}}
            text="About"
            path="/about"
          />
        </div>
        <div style={{display: 'flex', marginTop: 15}}>
          <Link
            customStyle={{fontWeight: 500, marginRight: 15, textSize: 18}}
            text="Term&Condition"
            path="/term"
          />
          <Link
            customStyle={{fontWeight: 500, marginRight: 15, textSize: 18}}
            text="Privacy"
            path="/privacy"
          />
        </div>
        <Divider />
        <div style={{color: '#9B9B9B'}}>
          Copyright © 2020 ThelazyStudio. All rights reserved.
        </div>
        <div style={{color: '#9B9B9B'}}>Made with ❤ by LazyTeam</div>
      </div>
      {/* <div style={{backgroundColor: '#1890ff', height: 50}}> </div> */}
    </div>
  );
});

export default Footer;
